let autoReturnedPaymentId: string | null = null;

export const markPaymentFailureAutoReturn = (paymentId: string): void => {
  autoReturnedPaymentId = paymentId;
};

export const takePaymentFailureAutoReturn = (paymentId: string | undefined): boolean => {
  if (paymentId === undefined || paymentId !== autoReturnedPaymentId) return false;
  autoReturnedPaymentId = null;
  return true;
};
